<div class="stepper-body">
    <div class="body-title">
        <span>What is your planned down payment?</span>
    </div>
    <div class="body-description">
        <span>Use the slider or enter an amount. This is calculated based on the {{ purchasePrice |
            currency:'USD':'symbol':'1.0-0' }} purchase price.</span>
    </div>
    <div class="body-answers custom-answers">
        <div class="custom-container">
            <form [formGroup]="formGroup">
                <div class="input-container">
                    <mat-slider class="slider-custom" min="10" max="100" step="1" thumbLabel tickInterval="10">
                        <input matSliderThumb [formControlName]="DownPaymentInputs.PercentageSlider" #slider>
                    </mat-slider>
                </div>
                <div class="input-container">
                    <mat-form-field appearance="outline" class="step-input">
                        <span matPrefix>$&nbsp;</span>
                        <input matInput currencyMask [options]="currencyOptions"
                            [formControlName]="DownPaymentInputs.DownPayment" [required]="true" />
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="step-input step-input2">
                        <span matSuffix>%</span>
                        <input matInput [formControlName]="DownPaymentInputs.Percentage" [required]="true"
                            type="number" />
                    </mat-form-field>
                </div>
                <div *ngIf="formGroup.hasError('downPaymentTooLow')" class="form-error">
                    The down payment is too low. Please increase it so your monthly payment is less than your income.
                </div>
            </form>
        </div>
    </div>
</div>
<div class="stepper-footer">
    <mat-divider></mat-divider>
    <div class="step-controls">
        <button mat-stroked-button color="primary" (click)="onBack()"
            class="step-button secondary" [disabled]="false">
            Back
        </button>
        <button mat-flat-button color="primary" (click)="onNext()" class="step-button primary"
            [disabled]="isNextDisabled()">
            Next
        </button>
    </div>
</div>